export default __webpack_public_path__ + "static/pragicts-ai-hotels-006d4ccc33a5c7a757e67452a80379f1.jpg";